/**
 * Custom hook to lock and unlock body scroll based on the `open` state.
 *
 * When `open` is true, the body scroll is locked, preventing the user from scrolling.
 * When `open` is false, the body scroll is unlocked, allowing the user to scroll again.
 *
 * It's required to use position: fixed to lock the body scroll, because overflow: hidden isn't supported on iOS devices for body tag.
 *
 * @param open - A boolean indicating whether to lock (true) or unlock (false) the body scroll.
 */
import { useEffect } from "react";

export const useBodyScrollLock = (open: boolean) => {
  useEffect(() => {
    if (open) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      if (document.body.style.top) {
        const scrollY = parseInt(document.body.style.top, 10);
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, -scrollY);
      }
    }
  }, [open]);
};

